// AG Grid 国际化配置 - 中文
export default {
  // 基础文本
  noRowsToShow: '暂无数据',
  loadingOoo: '加载中...',

  // 分页
  page: '页',
  more: '更多',
  to: '至',
  of: '共',
  next: '下一页',
  last: '最后一页',
  first: '第一页',
  previous: '上一页',

  // 行选择
  selectAll: '全选',
  selectAllFiltered: '全选（已筛选）',
  deselectAll: '取消全选',

  // 列操作
  columns: '列',
  filters: '筛选器',

  // 右键菜单
  copy: '复制',
  copyWithHeaders: '复制（含表头）',
  paste: '粘贴',
  export: '导出',
  csvExport: '导出为 CSV',
  excelExport: '导出为 Excel',
  exportSelectedRows: '导出选中行',
  exportCurrentPage: '导出当前页',
  exportSelectedRowsExcel: '导出选中行 (Excel)',
  exportSelectedRowsCsv: '导出选中行 (CSV)',
  exportAllRowsExcel: '导出全部 (Excel)',
  exportAllRowsCsv: '导出全部 (CSV)',
  exportCurrentPageExcel: '导出当前页 (Excel)',
  exportCurrentPageCsv: '导出当前页 (CSV)',

  // 列操作菜单
  pinColumn: '固定列',
  pinLeft: '左固定',
  pinRight: '右固定',
  noPin: '取消固定',
  valueAggregation: '值聚合',
  autosizeThiscolumn: '自动调整此列宽度',
  autosizeAllColumns: '自动调整所有列宽度',
  groupBy: '分组',
  ungroupBy: '取消分组',
  resetColumns: '重置列',
  expandAll: '展开全部',
  contractAll: '收起全部',

  // 筛选器
  filterOoo: '筛选...',
  equals: '等于',
  notEqual: '不等于',
  lessThan: '小于',
  greaterThan: '大于',
  lessThanOrEqual: '小于等于',
  greaterThanOrEqual: '大于等于',
  inRange: '范围内',
  contains: '包含',
  notContains: '不包含',
  startsWith: '开始于',
  endsWith: '结束于',
  blank: '空白',
  notBlank: '非空白',

  // 筛选器按钮
  applyFilter: '应用筛选',
  clearFilter: '清除筛选',
  resetFilter: '重置筛选',
  cancelFilter: '取消',

  // 文本筛选器
  textFilter: '文本筛选',
  numberFilter: '数字筛选',
  dateFilter: '日期筛选',
  setFilter: '设置筛选',

  // 筛选条件
  andCondition: '且',
  orCondition: '或',

  // 排序
  sortAscending: '升序排列',
  sortDescending: '降序排列',
  sortUnSort: '取消排序',

  // 工具面板
  toolPanelColumns: '列',
  toolPanelFilters: '筛选器',

  // 列工具面板
  pivotMode: '透视模式',
  groups: '行分组',
  rowGroupColumnsEmptyMessage: '拖拽到此处设置行分组',
  values: '值',
  valueColumnsEmptyMessage: '拖拽到此处进行聚合',
  pivots: '列标签',
  pivotColumnsEmptyMessage: '拖拽到此处设置列标签',

  // 其他
  loadingError: '加载出错',
  refreshHeaderFailed: '刷新表头语言文案失败',
  noDataToShow: '无数据显示',
  enabled: '启用',

  // 输入验证
  invalidDate: '无效日期',
  invalidNumber: '无效数字',

  // 分组
  group: '分组',

  // 主从表展开列
  expandRows: '展开',
  collapseRows: '折叠',

  // 透视
  pivot: '透视',

  // 企业版功能
  pivotChartAndPivotMode: '透视图表和透视模式',
  pivotChart: '透视图表',
  chartRange: '图表范围',

  // 状态栏
  sum: '求和',
  min: '最小值',
  max: '最大值',
  none: '无',
  count: '计数',
  avg: '平均值',

  // 搜索
  searchOoo: '搜索...',

  // 行拖拽
  rowDragEntireRow: '拖拽整行',
  rowDragRow: '拖拽行',

  // 其他企业版功能
  pivotColumnGroupTotals: '透视列分组总计',
  pivotRowTotals: '透视行总计',
  pivotColumnGroupTotal: '总计',

  // 侧边栏
  sideBarColumns: '列',
  sideBarFilters: '筛选器',

  // 列可见性
  visible: '可见',
  hidden: '隐藏'
}
